import Share from 'ninelines-sharing';

$('[data-social]').on('click', (e) => {
	const social = $(e.currentTarget).data('social');
	let url = location.origin;
	let page = location.pathname.slice(1) + location.search;

	if (page.indexOf('result') !== -1) {
		page = page.split('&')[0];
	}

	url += `/share.php?page=${encodeURIComponent(page)}`;

	Share[social](url);
});
